<template lang="pug">
footer
  SelectorLength(v-if="!$mq.desktop")
  SelectorMatchDelay
  nav
    button(@click.stop.prevent="clearModel") Clear Selections
    button(@click.stop.prevent="navigate", :class="{ disabled }") Continue
</template>

<script>
import SelectorLength from "@/components/configurator/SelectorLength";
import SelectorMatchDelay from "@/components/configurator/SelectorMatchDelay";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "ConfiguratorFooter",
  components: {
    SelectorLength,
    SelectorMatchDelay,
  },
  computed: {
    ...mapGetters(["model", "validity", "touched", "configID"]),
    disabled() {
      return !this.validity();
    },
  },
  methods: {
    ...mapMutations(["clearModel", "setTouched"]),
    navigate() {
      this.setTouched();
        if (this.validity()) {            
            let { configID } = this;


            this.$router.push({
                path: `configuration/${configID}`,
                query: {
                    length: this.model.length,
                    delay: this.model.match ? 1 : 0
                }
            });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1.5rem;

  @include mq(lg) {
    align-items: flex-end;
    justify-content: center;
  }
}

nav {
  display: flex;
  gap: clamp(1.125rem, 3vw, 2rem);
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  appearance: none;
  border: none;
  border-radius: 0;
  transition: 0.25s ease;
  padding: 0.75rem 1.25rem;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 0.6875rem;
  min-height: 40px;
  background: $buttonHighlightBackground;
  color: $buttonHighlightColor;

  &:hover {
    background: $buttonHighlightBackgroundHover;
    color: $buttonHighlightColorHover;
  }

  &.disabled {
    background: $buttonTertiaryBackground;
    color: $buttonTertiaryColor;
    &:hover {
      background: $buttonTertiaryBackgroundHover;
      color: $buttonTertiaryColorHover;
    }
  }

  &:nth-child(1) {
    background: $buttonGhostBackground;
    color: $buttonGhostColor;
    border: 1px solid $buttonGhostBorder;
    &:hover {
      background: $buttonGhostBackgroundHover;
      border-color: $buttonGhostBorderHover;
      color: $buttonGhostColorHover;
    }
  }
}
</style>